'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _basket = require('redux/actions/basket');

var _auth = require('redux/actions/auth');

var _registration = require('redux/actions/registration');

var _modal = require('redux/actions/modal');

var _reactRouterRedux = require('react-router-redux');

var _voice_code = require('redux/actions/voice_code');

var _modal_type = require('redux/actions/modal_type');

var _pass_recovery = require('redux/actions/pass_recovery');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthOneClick = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        loginError: state.auth.loginError,
        loginErrorCode: state.auth.loginErrorCode,
        user: state.auth.user,
        preload: state.auth.preload,
        orderInOneClick: state.setting.orderInOneClick,
        shopId: state.setting.shopId,
        googleCaptcha: state.setting.googleCaptcha,
        googleCaptchaSitekey: state.setting.googleCaptchaSitekey,
        basketElements: state.basket.items,
        lang: state.lang,
        currency: state.currency
    };
}, {
    login: _auth.login,
    hide: _modal.hide,
    showModalRegistration: _modal_type.showModalRegistration,
    resetError: _auth.resetError,
    showModalPassRecovery: _modal_type.showModalPassRecovery,
    sendPhoneToReducer: _pass_recovery.sendPhoneToReducer,
    registrationOneClick: _registration.registrationOneClick,
    confirmRegistrationOneClick: _registration.confirmRegistrationOneClick,
    resetVoiceCode: _voice_code.resetVoiceCode,
    resetStep: _pass_recovery.resetStep,
    createOrder: _basket.createOrder, clearBasket: _basket.clearBasket, push: _reactRouterRedux.push
}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(AuthOneClick, _BaseForm);

    function AuthOneClick(props) {
        (0, _classCallCheck3.default)(this, AuthOneClick);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthOneClick.__proto__ || (0, _getPrototypeOf2.default)(AuthOneClick)).call(this, props));

        _this.callCreateOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;

            _this.props.push('/basket');
            _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
                _this.props.clearBasket();
                _this.props.push('/create-order/' + result.result.order_id);
            }).catch(function (err) {
                //Ошибка "предложение не найдено"
                if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
                    console.log('предложение не найдено', err);
                    err.dataError.forEach(function (item) {
                        _this.props.deleteProduct(item);
                    });

                    var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];

                    setTimeout(function () {
                        _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                    }, 0);
                }

                //Ошибка: алкогольные товары в корзине
                if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
                    _this._showAlcoWarning(err.dataError);
                }
            });
        };

        _this._compileOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var sum = 0;
            var products = [];
            basketElements.map(function (element) {
                sum += element.price * element.count;
                products.push({
                    offer_id: element.id,
                    quantity: element.count,
                    price: element.price,
                    modifier_option_id: element.modifier_option_id,
                    modifier_option_name: element.modifier_option_name,
                    nestedOffers: element.nested_offer,
                    coupon_id: element.coupon_id, coupon_token: element.coupon_token, customer_coupon_id: element.customer_coupon_id
                });
            });
            var userAgent = navigator.userAgent || '';
            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');
            var currency_id = _this.props.currency.id;
            if (_this.state.editOrderId) {
                var order_id = _this.state.editOrderId;
                return { order_id: order_id, sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
            }
            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
        };

        _this.validateField = function (field) {};

        _this.onClickConfirmOneClick = function (event) {
            _this.props.confirmRegistrationOneClick({
                shopId: _this.props.shopId,
                login: _this.state.login,
                emailCode: _this.state.emailCode,
                smsCode: _this.state.phoneCode });
        };

        _this.onClickOneClick = function (event) {
            if (_this.props.googleCaptcha && _this.state.captcha == null) {
                var alertMessage = _this.props.lang['user.errorInvalidCaptcha'];
                setTimeout(function () {
                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                }, 0);
                return null;
            }
            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login, captcha: _this.state.captcha }).then(function (result) {
                _this.setState({ newUser: result.new_user });
                if (result.send_for_phone) {
                    _this.setState({ codeSendFor: 'phone' });
                } else if (result.send_for_email) {
                    _this.setState({ codeSendFor: 'email' });
                }
            });
        };

        _this.onClickResendCode = function (event) {
            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login }).then(function (result) {
                _this.setState({ timeToResentCode: 60 });
                var timerId = setInterval(function () {
                    _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
                }, 1000);
                setTimeout(function () {
                    clearInterval(timerId);
                }, 60000);
            });
        };

        _this.onClickRegistration = function (event) {
            _this.props.showModalRegistration(_this.props.lang);
        };

        _this.onClickPassRecovery = function (event) {
            _this.props.resetStep();
            _this.props.sendPhoneToReducer(_this.state.login);
            _this.props.showModalPassRecovery(_this.props.lang);
        };

        _this.onSuccessCaptcha = function (value) {
            _this.setState({ captcha: value });
        };

        _this.showCaptcha = function () {
            if (_this.props.googleCaptcha) {
                setTimeout(function () {
                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
                }, 500);
                // return (
                //     <Recaptcha
                //         sitekey={this.props.googleCaptchaSitekey}
                //         render="explicit"
                //         onChange={this.onSuccessCaptcha}
                //     />
                // );
            }

            return '';
        };

        _this.show = function () {
            if (_this.props.googleCaptcha) {
                setTimeout(function () {
                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
                }, 500);
                // return (
                //     <Recaptcha
                //         sitekey={this.props.googleCaptchaSitekey}
                //         render="explicit"
                //         onChange={this.onSuccessCaptcha}
                //     />
                // );
            }

            return '';
        };

        _this.state = {
            login: '',
            password: '',
            captcha: null,
            needCaptcha: false,
            waitingCode: false,
            codeSendFor: '',
            emailCode: '',
            phoneCode: '',
            newUser: true,
            timeToResentCode: 0
        };
        return _this;
    }

    (0, _createClass3.default)(AuthOneClick, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.loginError && nextProps.loginErrorCode === 'user.errorInvalidCaptcha') {
                this.setState({ needCaptcha: true });
            }

            if (nextProps.user && (nextProps.user.phone || nextProps.user.email)) {
                this.setState({ login: '', password: '' });
                this.props.hide();
                if (this.props.isCreateOrder) {
                    this.callCreateOrder();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.state.login.length > 0 && this.state.password.length > 0;
        }
    }, {
        key: 'onSubmit',


        /**
         * @param {SyntheticMouseEvent} event
         */
        value: function onSubmit(event) {
            event.preventDefault();
            if (this.props.googleCaptcha && this.state.captcha == null) {
                var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
                setTimeout(function () {
                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                }, 0);
                return null;
            }
            this.props.login({ login: this.state.login, password: this.state.password, captcha: this.state.captcha, callback: null, shopId: this.props.shopId });
        }
    }, {
        key: 'isValidOneClick',
        value: function isValidOneClick() {
            if (this.state.codeSendFor === 'phone') {
                return this.state.phoneCode.length > 0;
            }
            if (this.state.codeSendFor === 'email') {
                return this.state.emailCode.length > 0;
            }
            return this.state.login.length > 5;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('AuthOneClick', null, { folderName: 'Auth' });
            return _react2.default.createElement(View, { loginError: this.props.loginError,
                validateField: this.validateField,
                changeField: this.changeField,
                onSubmit: this.onSubmit,
                onClickOneClick: this.onClickOneClick,
                onClickConfirmOneClick: this.onClickConfirmOneClick,
                onClickRegistration: this.onClickRegistration,
                onClickPassRecovery: this.onClickPassRecovery,
                disabledSubmit: !this.isValid(),
                disabledSubmitOneClick: !this.isValidOneClick(),
                login: this.state.login,
                password: this.state.password,
                preload: this.props.preload,
                orderInOneClick: this.props.orderInOneClick,
                showCaptcha: this.showCaptcha,
                loginErrorCode: this.props.loginErrorCode,
                codeSendFor: this.state.codeSendFor,
                newUser: this.state.newUser,
                emailCode: this.state.emailCode,
                phoneCode: this.state.phoneCode,
                timeToResentCode: this.state.timeToResentCode,
                onClickResendCode: this.onClickResendCode,
                lang: this.props.lang
            });
        }
    }]);
    return AuthOneClick;
}(_BaseForm3.default), _class2.propTypes = {
    showModalRegistration: _react.PropTypes.func.isRequired,
    resetError: _react.PropTypes.func.isRequired,
    hide: _react.PropTypes.func.isRequired,
    lang: _react.PropTypes.object,
    currency: _react.PropTypes.object
}, _temp)) || _class);
exports.default = AuthOneClick;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/AuthOneClick.jsx
// module id = 1605
// module chunks = 0